"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactTransitionGroup = require("react-transition-group");
var _createStyles = require("../styles/createStyles");
var _transitions = require("../styles/transitions");
var _useTheme = require("../styles/useTheme");
var _getTransitionProps = require("../utilities/getTransitionProps");
var _useForkRef = _interopRequireDefault(require("../utilities/useForkRef"));
const _excluded = ["children", "classes", "className", "collapsedHeight", "component", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "timeout"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },
    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },
    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
    hidden: {
      visibility: 'hidden'
    },
    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },
    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
});
/**
 * **❗️ DEPRECATED**: Use the new `Collapse` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/utilities-collapse):
 *
 * ```tsx
 * import { Collapse } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/utilities-collapse)
 *
 * @deprecated
 */
const Collapse = /*#__PURE__*/_react.default.forwardRef(function Collapse(props, ref) {
  const {
      children,
      classes: classesOverrides,
      className,
      collapsedHeight: collapsedHeightProp = '0px',
      component: Component = 'div',
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExiting,
      style,
      timeout = _transitions.duration.standard
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = useStyles({
    classesOverrides
  });
  const theme = (0, _useTheme.useTheme)();
  const timer = _react.default.useRef();
  const wrapperRef = _react.default.useRef(null);
  const autoTransitionDuration = _react.default.useRef();
  const collapsedHeight = typeof collapsedHeightProp === 'number' ? `${collapsedHeightProp}px` : collapsedHeightProp;
  const nodeRef = _react.default.useRef(null);
  const handleRef = (0, _useForkRef.default)(nodeRef, ref);
  _react.default.useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    node.style.height = collapsedHeight;
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    const {
      duration: transitionDuration
    } = (0, _getTransitionProps.getTransitionProps)({
      style,
      timeout
    }, {
      mode: 'enter'
    });
    if (timeout === 'auto') {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style.height = `${wrapperHeight}px`;
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback((node, isAppearing) => {
    node.style.height = 'auto';
    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  const handleExit = normalizedTransitionCallback(node => {
    const wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = `${wrapperHeight}px`;
    if (onExit) {
      onExit(node);
    }
  });
  const handleExiting = normalizedTransitionCallback(node => {
    const wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    const {
      duration: transitionDuration
    } = (0, _getTransitionProps.getTransitionProps)({
      style,
      timeout
    }, {
      mode: 'exit'
    });
    if (timeout === 'auto') {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style.height = collapsedHeight;
    if (onExiting) {
      onExiting(node);
    }
  });
  const addEndListener = next => {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    nodeRef: nodeRef,
    timeout: timeout === 'auto' ? undefined : timeout
  }, other), (state, childProps) => /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: cx(classes.container, {
      [classes.entered]: state === 'entered',
      [classes.hidden]: state === 'exited' && !inProp && collapsedHeight === '0px'
    }, className),
    style: _objectSpread({
      minHeight: collapsedHeight
    }, style),
    ref: handleRef
  }, childProps), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper,
    ref: wrapperRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapperInner
  }, children))));
});

// Needed for Popover component
// @ts-ignore
Collapse.muiSupportAuto = true;
var _default = exports.default = Collapse;